import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-viewordervendor',
  templateUrl: './viewordervendor.component.html',
  styleUrls: ['./viewordervendor.component.css']
})
export class ViewordervendorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
